import React from "react";
import '../App.css';

const Terms = () => {
  return (
    <div id="about" className="container py-5">
      <div className="row">
        <div id="enlargedText" className="col-lg-15 col-xm-12">
          <h1 className="about-heading">Terms & Conditions</h1>

          <p><strong>Effective Date:</strong> November 3, 2026</p>

          <h4>1. Introduction</h4>
          <p>
            MYAPPS LABS LTD ("myapps.", "we," "our," or "us") provides mobile applications and services.
            By downloading, installing, or using our apps, you agree to these Terms.
            If you do not agree, please do not use the apps.
          </p>

          <h4>2. Use of Services</h4>
          <p>
            You are granted a limited, non-exclusive, non-transferable, revocable license to use our apps
            for personal, non-commercial use only, in accordance with these Terms and the terms of the app store
            from which you downloaded the app. You may not copy, modify, distribute, sell, or reverse engineer
            the apps, except where permitted by law.
          </p>

          <h4>3. Device Compatibility</h4>
          <p>
            Our apps depend on device compatibility and network conditions.
            Some features require that your mobile device and the target device be connected to the same local network.
            We do not guarantee that all features will work on all devices.
          </p>

          <h4>4. Remote Control & Casting Disclaimer</h4>
          <p>
            Our apps are not affiliated with, endorsed by, or sponsored by any TV brand or manufacturer.
            Brand names referenced in the apps are the property of their respective owners and are used
            for identification and compatibility purposes only. Functionality depends on third-party devices and may vary.
          </p>

          <h4>5. In-App Purchases & Subscriptions</h4>
          <p>
            Some apps offer optional one-time purchases or auto-renewing subscriptions.
          </p>
          <ul>
            <li>
              <strong>Billing:</strong> payment is charged to your Apple App Store, Google Play, or Huawei AppGallery account
              upon confirmation of purchase.
            </li>
            <li>
              <strong>Auto-renewal:</strong> subscriptions renew automatically for the same period at the then-current price
              unless cancelled at least 24 hours before the end of the current period.
            </li>
            <li>
              <strong>Free trials:</strong> if a free trial is offered, any unused portion of the trial is forfeited
              when you purchase a subscription, where applicable.
            </li>
            <li>
              <strong>Managing and cancelling:</strong> you can manage or cancel your subscription at any time
              through your app store account settings. Deleting the app does not cancel your subscription.
            </li>
            <li>
              <strong>Refunds:</strong> purchases are processed by the app stores and are subject to their refund policies.
              We do not process payments ourselves and generally cannot issue refunds directly.
            </li>
          </ul>

          <h4>6. Advertising</h4>
          <p>
            Some apps display advertising provided by third parties, including Google AdMob and its mediation partners
            (Meta Audience Network, Pangle, and the Yandex Advertising Network) on Google Play and Apple App Store versions,
            and HUAWEI Ads Kit (Petal Ads) and the Yandex Advertising Network on Huawei AppGallery versions.
            Subscriptions may remove or reduce advertising as described within the app.
            We are not responsible for the content of third-party advertisements or any websites or offers they link to.
          </p>

          <h4>7. Third-Party Services</h4>
          <p>
            Our apps rely on third-party services, including Google AdMob, Meta Audience Network, Pangle,
            the Yandex Advertising Network, Google Firebase, HUAWEI Ads Kit, RevenueCat, Microsoft Azure,
            and the Apple App Store, Google Play, and Huawei AppGallery platforms.
            Your use of these services may be subject to their own terms and policies.
          </p>

          <h4>8. Disclaimer of Warranties</h4>
          <p>
            The apps are provided "as is" and "as available" without warranties of any kind, express or implied.
            We do not warrant that the apps will be uninterrupted, error-free, or compatible with any particular device.
          </p>

          <h4>9. Limitation of Liability</h4>
          <p>
            To the maximum extent permitted by law, we are not liable for any indirect, incidental, or consequential damages,
            device issues, or data loss resulting from the use of, or inability to use, our apps.
          </p>

          <h4>10. Termination</h4>
          <p>
            We may suspend or terminate access if misuse is detected or these Terms are violated.
          </p>

          <h4>11. Governing Law</h4>
          <p>
            These Terms are governed by the laws of the State of Israel, without regard to conflict of law principles.
            Nothing in these Terms affects your statutory rights as a consumer.
          </p>

          <h4>12. Changes</h4>
          <p>
            We may update these Terms at any time. Changes take effect when posted, with the "Effective Date" above updated.
            Continued use of the apps after changes are posted constitutes acceptance of the revised Terms.
          </p>

          <h4>13. Contact</h4>
          <p>
            Email: <a href="mailto:matanyamindevelop@gmail.com">matanyamindevelop@gmail.com</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Terms;